import React from 'react';
import { Card, CardActions, CardHeader, CardMedia } from 'material-ui/Card';
import defaultPhoto from '../images/default_restaurant.png';
import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';

const RestaurantCard = ({ restaurant, onLocationsPressed }) => (
  <Card style={{ maxWidth: 342, margin: 5}}>
    <CardHeader
      title={restaurant.name}
      subtitle={restaurant.tagline}
    />
    <CardMedia>
      <img src={restaurant.photo || defaultPhoto} alt="" style={{  }} />
    </CardMedia>
    <CardActions>
      <RaisedButton primary label="Open" onTouchTap={onLocationsPressed} />
    </CardActions>
  </Card>
);

export default RestaurantCard;



// WEBPACK FOOTER //
// ./src/components/RestaurantCard.js